<div>
    <div class="row clear top-banner">
        <div class="col-lg-6 col-md-12 col-sm-12 clear">
            <div class="text-banner-container">
                <div class="text-lg">Apply for electric service with ease</div>
                <div class="text-md">Let us help you with your electric service application, safely and conveniently.</div>
                <div class="d-flex flex-column justify-content-start" style="width: 100%;">
                    <div class="input-group-title text-left" style="text-align: left; padding-left: 10px;">I am applying as:</div>
                    <div class="d-flex flex-row align-items-center">
                        <span class="customer-radio"
                              style="margin:10px"
                              [ngClass]="{'customer-radio-selected':apply_as == 'rep'}"
                              (click)="rep.click()">
                            <input type="radio"
                                   name="apply_as"
                                   #rep
                                   [(ngModel)]="apply_as"
                                   value="rep">
                        </span>
                        <span (click)="rep.click()"
                              style="cursor: pointer">Customer or Representative</span>
                    </div>
                    <div class="d-flex flex-row align-items-center">
                        <span class="customer-radio"
                              style="margin:10px"
                              [ngClass]="{'customer-radio-selected':apply_as == 'contractor'}"
                              (click)="contractor.click()">
                            <input type="radio"
                                   name="apply_as"
                                   #contractor
                                   [(ngModel)]="apply_as"
                                   value="contractor">
                        </span>
                        <span (click)="contractor.click()"
                              style="cursor: pointer">Contractor</span>
                    </div>
                    <div class="d-flex flex-row align-items-center">
                        <span class="customer-radio"
                              style="margin:10px"
                              [ngClass]="{'customer-radio-selected':apply_as == 'cbm'}"
                              (click)="cbm.click()">
                                <input type="radio"
                                       name="apply_as"
                                       #cbm
                                       [(ngModel)]="apply_as"
                                       value="cbm">
                        </span>
                        <span (click)="cbm.click()"
                              style="cursor: pointer;flex: 1;">Private Electrical Contractor Certified by Meralco</span>
                    </div>
                </div>
                <br>
                <button class="button button-active"
                        (click)="onRequestService()">Request Service</button>
            </div>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 position-relative clear">
            <img class="img-cover " src="assets/img/engineers-planning-work-outside.png" alt="cover">
            <div class="banner-0-inset"></div>
        </div>
    </div>
    <div class="row clear">
        <div class="col-lg-6 col-md-12 col-sm-12 position-relative clear" >
            <img class="img-cover" src="assets/img/engineers-analyzing-data-digital-tablet.png" alt="cover">
            <div class="banner-1-inset"></div>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 clear">
            <div class="text-banner-container">
                <div>
                    <div class="text-lg-40">
                        About Us
                    </div>
                    <div class="text-md">
                        <p class="text-justify">
                            Private electrical contractors certified by Meralco
                            can assist you with your application for electric service - from securing and submitting documentary requirements to installing your service entrance.
                        </p>
                        <p class="text-justify">
                            Private electrical contractors certified by Meralco are not employees or agents of Meralco nor are they subsidiaries or affiliates of Meralco.
                            Transactions made with them do not involve Meralco. Customers to deal directly with them at their discretion.
                        </p>
                        <a href="/about">Learn More...</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row clear">
        <div class="col-12 services clear">
            <br>
            <div class="text-lg-40 text-center">Our Services</div>
            <div class="text-md text-center">Avail of any of these service bundles for safe and convenient electric service application.
            </div>
            <br>
        </div>
    </div>
    <div class="row clear">
        <div class="col-12 services" style="padding-bottom: 50px">
            <div class="d-flex flex-row justify-content-center align-items-stretch flex-wrap">
                <div class="card_sm d-flex flex-column align-items-center">
                    <img src="assets/img/icons/MaskGroup58.png" class="card_icon" alt="bundle-icon">
                    <div class="card_title text-center">Full Bundle</div>
                    <div class="card_text text-center">
                        End-to-end processing of service application,
                        from securing and submission of documents and permits,
                        to installation of service entrance
                    </div>
                </div>
                <div class="card_sm d-flex flex-column align-items-center">
                    <img src="assets/img/icons/MaskGroup59.png" class="card_icon" alt="bundle-icon">
                    <div class="card_title text-center">Technical Bundle</div>
                    <div class="card_text text-center">
                        Materials and labor cost for the installation of service entrance
                    </div>
                </div>
                <div class="card_sm d-flex flex-column align-items-center">
                    <img src="assets/img/icons/MaskGroup60.png" class="card_icon" alt="bundle-icon">
                    <div class="card_title text-center">Documentary Bundle</div>
                    <div class="card_text text-center">
                        Service and transportation fees incurred in the processing of
                        required permits (i.e. CFEI) with the local government unit
                    </div>
                </div>
                <div class="card_sm d-flex flex-column align-items-center">
                    <img src="assets/img/icons/MaskGroup61.png" class="card_icon" alt="bundle-icon">
                    <div class="card_title text-center">Processing Bundle</div>
                    <div class="card_text text-center">
                        Service and transportation fees for the submission of documents and requirements to Meralco
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


